import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';

import Alert from 'components/Common/Alert';
import Button from 'components/Common/Button';

export class LoginEmail extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    status: PropTypes.object.isRequired,
    onLogin: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.state = { email: '', password: '' };
  }

  handleChangeInput = event => {
    const { name, value } = event.target;

    this.setState({ [name]: value });
  };

  handleSubmit = event => {
    this.props.onLogin(this.state.email, this.state.password);

    event.preventDefault();
  };

  renderError() {
    const description =
      this.props.status.error.response.status === 401
        ? this.props.t('login.email.errors.unauthorized')
        : this.props.t('login.email.errors.default');

    return <Alert description={description} />;
  }

  render() {
    return (
      <div>
        {this.props.status.error && this.renderError()}

        <form className="login__form" onSubmit={this.handleSubmit}>
          <label htmlFor="email">
            {this.props.t('login.email.form.email.label')}
          </label>
          <input
            type="email"
            placeholder={this.props.t('login.email.form.email.placeholder')}
            name="email"
            value={this.state.email}
            onChange={this.handleChangeInput}
          />

          <label htmlFor="password">
            {this.props.t('login.email.form.password.label')}
          </label>
          <input
            type="password"
            placeholder={this.props.t('login.email.form.password.placeholder')}
            name="password"
            value={this.state.password}
            onChange={this.handleChangeInput}
          />

          <Button type="submit" full isLoading={this.props.status.isLoading}>
            {this.props.t('login.email.form.submit.label')}
          </Button>
        </form>

        <p>
          <Link to="/forgot-password">
            {this.props.t('login.email.forgotPassword')}
          </Link>
        </p>
      </div>
    );
  }
}

export default translate()(LoginEmail);



// WEBPACK FOOTER //
// ./src/components/LoginEmail/LoginEmail.js